import React from 'react';
import Styles from './start.module.css';
import Power from '../images/Power.png';
import Logout from '../images/Logout.png';
import Flower from '../images/flower.jpg';

export default function Start({ openWindow, shortcuts }) {

  // Split the array
  const leftItems = shortcuts.slice(0, 4);   // first 4
  const rightItems = shortcuts.slice(4);     // rest

  return (
    <section className={`${Styles.start} start-menu`}>

      {/* USER HEADER */}
      <div className={Styles.head}>
        <div
          className={Styles.userIcon}
          style={{ backgroundImage: `url(${Flower})` }}
        ></div>
        <div className={Styles.userName}>User</div>
      </div>

      {/* MAIN MENU */}
      <div className={Styles.section}>

        {/* LEFT SIDE */}
        <div className={Styles.leftSide}>
          {leftItems.map(sc => (
            <div
              key={sc.id}
              className={Styles.menuItem}
              onDoubleClick={() => openWindow(sc.id)}
            >
              <div
                className={Styles.icon}
                style={{ backgroundImage: `url(${sc.image})` }}
              ></div>
              <span>{sc.label}</span>
            </div>
          ))}
        </div>

        {/* RIGHT SIDE */}
        <div className={Styles.rightSide}>
          {rightItems.map(sc => (
            <div
              key={sc.id}
              className={Styles.menuItem}
              onDoubleClick={() => openWindow(sc.id)}
            >
              <div
                className={Styles.icon}
                style={{ backgroundImage: `url(${sc.image})` }}
              ></div>
              <span>{sc.label}</span>
            </div>
          ))}
        </div>

      </div>

      {/* POWER BUTTONS */}
      <div className={Styles.power}>
        <div className={Styles.powerItem}>
          <div
            className={Styles.icon}
            style={{ backgroundImage: `url(${Logout})` }}
          ></div>
          <span>Log Off</span>
        </div>

        <div
          className={Styles.powerItem}
          onClick={() => window.dispatchEvent(new Event("shutdown"))}
        >
          <div
            className={Styles.icon}
            style={{ backgroundImage: `url(${Power})` }}
          ></div>
          <span>Turn Off Computer</span>
        </div>
      </div>

    </section>
  );
}
